import VueRouter from 'vue-router';
// 注册页
import loginIndex from '../views/login/index';
import mtgindex from '../views/login/mtgindex.vue';
import loginRegister from '../views/login/register';
import registerSuc from '../views/login/registerSuc';
import login from '../views/login/login';
import userlogin from '../views/login/userlogin.vue';
import mologin from '../views/login/mologin';
import moregister from '../views/login/moregister';
import mofindpsdOne from '../views/login/mofindpsdOne';
import sweep from '../views/login/sweep';
import getpass from '../views/login/getpass';
import getpassSuc from '../views/login/getpassSuc';
import wechatlogin from '../views/login/wechatlogin';
// 首页
import index from '../views/home/index';
import home from '../views/home/home';
// import health from '../views/home/health';
import health from '../views/home/healthnew';
// import build from '../views/home/build';
import build from '../views/home/buildnew';
import magazine from '../views/home/magazine';
// import magazine from '../views/home/magazinenew';
// import meeting from '../views/home/meeting';
import meeting from '../views/home/meetingnew';
import experts from '../views/home/experts';
import expertsDetail from '../views/home/expertsDetail';
import organization from '../views/home/organization';
import organDetail from '../views/home/organDetail';
// 列表详情页
import Inforlist from '../views/information/Inforlist';
import litelist from '../views/information/litelist';
// import litelist from '../views/information/litelistnew';
import litelist2 from '../views/information/litelist2';
// import litelist2 from '../views/information/litelist2new';
import inforDetails from '../views/information/inforDetails';
import litedetails from '../views/information/litedetails';
import specialHome from '../views/information/specialHome';
import specialHome2 from '../views/information/specialHome2';
import specialDetails from '../views/information/specialDetails';
import searchPage from '../views/information/searchPage';
import meetingList from '../views/information/meetingList';
// 企业专题
import enterprise from '../views/enterprise/index';
import qyhome from '../views/enterprise/home';
import enterpriseList from '../views/enterprise/enterpriseList';
import enterpriseList2 from '../views/enterprise/enterpriseList2';
import enterpriseDetail from '../views/enterprise/enterpriseDetail';

// 用户中心
import user from '../views/user/index';
import userInfor from '../views/user/userInfor';
import userData from '../views/user/userData';
import userMyInforShow from '../views/user/userMyInforShow';
import userSubscribe from '../views/user/userSubscribe';
import userSubscribeOpera from '../views/user/userSubscribeOpera';
import userSubscribeMenu from '../views/user/userSubscribeMenu';
import userVip from '../views/user/userVip';
import userMyCourse from '../views/user/userMyCourse';
import userCredits from '../views/user/userCredits';
import userCreditsPaySuccess from '../views/user/userCreditsPaySuccess';
import userShopping from '../views/user/userShopping';
import userMyOrder from '../views/user/userMyOrder';
import userMyInvoice from '../views/user/userMyInvoice';
import userMyCollection from '../views/user/userMyCollection';
import userExchange from '../views/user/userExchange';
import userMymsg from '../views/user/userMymsg';
import userMyMeeting from '../views/user/userMyMeeting';
import userorgCourse from '../views/user/userorgCourse';
import userCmeCourse from '../views/user/userCmeCourse';
import userExpertsEnter from '../views/user/userEnter/expertsEnter';
import userOrgEnter from '../views/user/userEnter/orgEnter';
import orgEnterUpdate from '../views/user/userEnter/orgEnterUpdate';
import expertsEnterUpdate from '../views/user/userEnter/expertsEnterUpdate';
import userStoreCenter from '../views/user/userStoreCenter';

//店铺后台
import userStore from '../views/userStore/index';
import usProject from '../views/userStore/project';
import usAddProject from '../views/userStore/addProject';
import usUpdateProject from '../views/userStore/updateProject';
import usStudent from '../views/userStore/student';
import usCreation from '../views/userStore/creation';
import usAccount from '../views/userStore/account';
import usInfor from '../views/userStore/infor';
import usShow from '../views/userStore/show';
import usLink from '../views/userStore/link';
import usUpdateLink from '../views/userStore/updateLink';
import usImageShow from '../views/userStore/imageShow';
import usVideoShow from '../views/userStore/videoShow';
import usStatistics from '../views/userStore/statistics';
import usEquity from '../views/userStore/equity';
import usElegant from '../views/userStore/elegant';
import usFeature from '../views/userStore/feature';
import usCourse from '../views/userStore/course';
import usCmeCourse from '../views/userStore/cmeCourse';
import usCmeCredits from '../views/userStore/cmeCredits';
import usCmeStatis from '../views/userStore/cmeStatis';
import usCmeCdkey from '../views/userStore/cmeCdkey';

//专家店铺后台
import userAdmin from '../views/userStore/index';
import uaInfor from '../views/userAdmin/infor';
import uaPaper from '../views/userAdmin/paper';
import uaWorks from '../views/userAdmin/works';
import uaBroadcast from '../views/userAdmin/broadcast';
import uaDynamic from '../views/userAdmin/dynamic';
import uaManagement from '../views/userAdmin/management';
import uaLink from '../views/userAdmin/link';
import uaCenter from '../views/userAdmin/center';
import uaFans from '../views/userAdmin/fans';
import uaAccount from '../views/userAdmin/account';
import uaLeaveWord from '../views/userAdmin/leaveWord';
import uaUpdateDynamic from '../views/userAdmin/updateDynamic';
import uaUpdateLink from '../views/userAdmin/updateLink';

//订单
import OpenInvoice from '../views/Personal/OpenInvoice';
import Invoicedetail from '../views/Personal/Invoicedetail';
import paySuccess from '../views/user/paySuccess';

// 会议
import meetingIndex from '../views/meeting/index';
// import meetingpc from '../views/meeting/meetingpc';
import meetingpc from '../views/meeting/newmeetingpc';
import meetingDetail from '../views/meeting/meetingDetail';
import meetingMobile from '../views/meeting/meetingMobile';
import meetingMobileDetail from '../views/meeting/meetingMobileDetail';
import meetingMobileIndex from '../views/meeting/mobileindex';
import muduLive from '../views/meeting/muduLive';
import huodeLive from '../views/meeting/huodeLive';
import muduLiveMobile from '../views/meeting/mobile_muduLive';
import huodeLiveMobile from '../views/meeting/mobile_huodeLive';
import channelList from '../views/meeting/channelList';
import channelListMobile from '../views/meeting/mobile_channelList';
import question from '../views/meeting/question';
import questionSuccess from '../views/meeting/questionSuccess';
import livelist from '../views/live/list';
import xcx from '../views/meeting/xcx';
//杂志
// import magazineindex from '../views/information/index'
import routeReplaceSelf from '../assets/unit/routeReplaceSelf';

// 机构入口

import mechanismIndex from '../views/mechanismEnter/index';
import mechanismHome from '../views/mechanismEnter/mechanismHome';
import mechanismDetail from '../views/mechanismEnter/mechanismDetail';

// 专家入口
import expertEnter from '../views/mechanismEnter/expertEnter';
import expertDetails from '../views/mechanismEnter/expertDetails';
import expertLiterature from '../views/mechanismEnter/expertLiterature';

// 全科知家
import qkIndex from '../views/qkcollege/index';
import qkHome from '../views/qkcollege/home';
import qkNationalCourse from '../views/qkcollege/qkNationalCourse';
import qkallCourse from '../views/qkcollege/qkallCourse';
import qkCourseDetails from '../views/qkcollege/qkCourseDetails';
import qkExpert from '../views/qkcollege/qkExpert';
import qkExpertDetail from '../views/qkcollege/qkExpertDetail';

// 证书查询
import queryList from '../views/query/list';
import queryDetail from '../views/query/detail';

// 读书节
import reading from '../views/reading';

// 科普大赛
import popsci from '../views/PopSci';

// 英文页面
import enindex from '../views/english/index';
import enhome from '../views/english/home';
import enInforList from '../views/english/enInforList';
import enLiteList from '../views/english/enLiteList';
import enLiteList2 from '../views/english/enLiteList2';
import enLiteList3 from '../views/english/enLiteList3';
import enInforDetail from '../views/english/enInforDetail';
import enLiteDetail from '../views/english/enLiteDetail';
import enLiteDetail2 from '../views/english/enLiteDetail2';
//Loading
import Loading from '@/views/components/Loading/Loading';

/**扩展 */
import baywindow from '../views/Expand/baywindow';
import ssologin from '../views/login/ssologin';
import course from '../views/course';
import mcourse from '../views/course/mindex.vue';
import wxlogin from '../views/login/wxlogin.vue';
/**404 */
import nopage from '../views/nopage';

/**测试web直传OSS */
import uploaddemo from '../views/uploadDemo';
//测试页面
import test from '../views/test';

/**我的直播 */
import userLive from '../views/user/liveinfo';
import livesub from '../views/user/liveinfo/livesub.vue';
import liveorder from '../views/user/liveinfo/liveorder.vue';
import livecollect from '../views/user/liveinfo/livecollect.vue';
import liveclass from '../views/user/liveinfo/liveclass.vue';
const routes = [
    { path: '', redirect: '/home' },
    { path: '/test888', component: test },
    {
        path: '/home',
        name: 'home',
        component: index,
        redirect: '/home',
        meta: {
            navShow: true,
            breadcrumbTitle: '首页',
            content: {
                keywords: '全科医学网,全科医学,医学,全科,全科医学,全科医学网,杂志,全科医学杂志,学术会议,基层卫生,学科,基层,学科建设,病例',
                description:
                    '全科医学网为医生提供相应的平台技术服务，医生用户自行发布其个人信息及相关内容，医生用户应确保其发布的信息的真实性、合法性、时效性。医生用户通过全科医学网发布的所有其个人基本信息、医学相关内容等，并不代表全科医学网赞同其观点或证实其内容的真实性，也不能作为临床诊断及医疗的依据，且不能替代正规医院医生与病人面对面的诊疗',
            },
        },
        children: [
            {
                path: '',
                name: 'home',
                component: home,
                meta: {
                    navShow: true,
                    activeNum: 0,
                    title: '全科医学网',
                    content: {
                        keywords: '全科医学网,全科医学,医学,全科,全科医学网,全科医学网,杂志,全科医学网杂志,学术会议,基层卫生,学科,基层,学科建设,病例,课程,全科知家,学术,会议',
                        description:
                            '全科医学网为医生提供相应的平台技术服务，医生用户自行发布其个人信息及相关内容，医生用户应确保其发布的信息的真实性、合法性、时效性。医生用户通过全科医学网发布的所有其个人基本信息、医学相关内容等，并不代表全科医学网赞同其观点或证实其内容的真实性，也不能作为临床诊断及医疗的依据，且不能替代正规医院医生与病人面对面的诊疗',
                    },
                },
            },
            {
                path: 'Inforlist',
                name: 'home/Inforlist',
                component: routeReplaceSelf(Inforlist),
                meta: {
                    navShow: true,
                    title: '中文资讯列表页',
                    breadcrumbTitle: '资讯列表',
                },
                children: [
                    {
                        path: 'inforDetails',
                        name: 'inforDetails',
                        component: inforDetails,
                        meta: {
                            navShow: true,
                            title: '中文资讯详情',
                            breadcrumbTitle: '资讯详情',
                        },
                    },
                ],
            },
            {
                path: 'meetingList',
                name: 'meetingList',
                component: meetingList,
                meta: {
                    navShow: true,
                    title: '会议列表',
                    activeNum: 4,
                    breadcrumbTitle: '会议列表',
                },
            },
            {
                path: 'inforDetails',
                name: 'inforDetails',
                component: inforDetails,
                meta: {
                    navShow: true,
                    title: '中文资讯详情',
                    breadcrumbTitle: '资讯详情',
                },
            },
            {
                path: 'specialRecomme',
                name: 'specialRecomme',
                component: specialHome,
                meta: {
                    navShow: true,
                    title: '专题',
                    breadcrumbTitle: '资讯专题首页',
                },
            },
            {
                path: 'specialHome2',
                name: 'specialHome2',
                component: specialHome2,
                meta: {
                    navShow: true,
                    title: '资讯专题首页2',
                    breadcrumbTitle: '资讯专题首页2',
                },
            },
            {
                path: 'specialDetails',
                name: 'specialDetails',
                component: specialDetails,
                meta: {
                    navShow: true,
                    title: '资讯专题详情页',
                    breadcrumbTitle: '资讯专题详情',
                },
            },
            {
                path: 'searchPage',
                name: 'searchPage',
                component: searchPage,
                meta: {
                    navShow: true,
                    title: '搜索页面',
                    breadcrumbTitle: '搜索',
                },
            },
        ],
    },
    {
        path: '/loginIndex',
        name: 'loginIndex',
        component: loginIndex,
        children: [
            {
                path: 'loginRegister',
                name: 'loginRegister',
                component: loginRegister,
                meta: { title: '全科医学网-注册' },
            },
            {
                path: 'registerSuc',
                name: 'registerSuc',
                component: registerSuc,
            },
            {
                path: 'login',
                name: 'login',
                component: login,
                meta: { title: '全科医学网-登录' },
            },
            {
                path: 'sweep',
                name: 'sweep',
                component: sweep,
                meta: { title: '全科医学网-微信扫码登录' },
            },
            {
                path: 'wechatlogin',
                name: 'wechatlogin',
                component: wechatlogin,
                meta: { title: '全科医学网-微信扫码成功' },
            },
            {
                path: 'getpass',
                name: 'getpass',
                component: getpass,
                meta: { title: '全科医学网-找回密码' },
            },
            {
                path: 'getpassSuc',
                name: 'getpassSuc',
                component: getpassSuc,
                meta: { title: '全科医学网' },
            },
            {
                path: 'ssologin',
                name: 'ssologin',
                component: ssologin,
                meta: { title: '' },
            },
        ],
    },
    {
        path: '/mtgindex',
        name: 'mtgindex',
        component: mtgindex,
        children: [
            {
                path: 'userlogin',
                name: 'userlogin',
                component: userlogin,
                meta: { title: '登录' },
            },
            {
                path: 'sweep',
                name: 'mtgsweep',
                component: sweep,
                meta: { title: '微信扫码登录' },
            },
            {
                path: 'wechatlogin',
                name: 'mtgwechatlogin',
                component: wechatlogin,
                meta: { title: '微信扫码成功' },
            },
            {
                path: 'ssologin',
                name: 'ssologin',
                component: ssologin,
                meta: { title: '' },
            },
        ],
    },
    {
        path: '/mologin',
        name: 'mologin',
        component: mologin,
        meta: { title: '全科医学网-登录' },
    },
    {
        path: '/moregister',
        name: 'moregister',
        component: moregister,
        meta: { title: '全科医学网-注册' },
    },
    {
        path: '/mofindpsdOne',
        name: 'mofindpsdOne',
        component: mofindpsdOne,
        meta: { title: '全科医学网-找回密码' },
    },
    {
        path: '/grassheal',
        name: 'grassheal',
        component: routeReplaceSelf(health),
        meta: {
            navShow: true,
            activeNum: 1,
            breadcrumbTitle: '基层卫生',
            title: '全科医学网-基层卫生',
        },
        children: [
            {
                path: 'Inforlist',
                name: 'grassheal/Inforlist',
                component: routeReplaceSelf(Inforlist),
                meta: {
                    activeNum: 1,
                    navShow: true,
                    title: '资讯列表',
                    breadcrumbTitle: '资讯列表',
                },
                children: [
                    {
                        path: 'inforDetails',
                        name: 'grassheal/inforDetails',
                        component: inforDetails,
                        meta: {
                            activeNum: 1,
                            navShow: true,
                            title: '详情',
                            breadcrumbTitle: '详情',
                        },
                    },
                ],
            },
        ],
    },
    {
        path: '/journal',
        name: 'journal',
        component: routeReplaceSelf(magazine),
        // redirect: '/magazine',
        meta: {
            navShow: true,
            activeNum: 2,
            breadcrumbTitle: '杂志专区',
            title: '全科医学网-杂志专区',
        },
        children: [
            {
                path: 'magazinesectionlist',
                name: 'magazinesectionlist',
                component: litelist,
                meta: {
                    activeNum: 2,
                    navShow: true,
                    title: '期刊浏览',
                    breadcrumbTitle: '期刊浏览',
                },
            },
            {
                path: 'magazinejournal',
                name: 'magazinejournal',
                component: routeReplaceSelf(litelist2),
                meta: {
                    navShow: true,
                    activeNum: 2,
                    title: '文献列表',
                    breadcrumbTitle: '文献列表',
                },
                children: [
                    {
                        path: 'magazinejournaldetail',
                        name: 'magazinejournaldetail',
                        component: litedetails,
                        meta: {
                            navShow: true,
                            activeNum: 2,
                            title: '文献详情',
                            breadcrumbTitle: '文献详情',
                        },
                    },
                ],
            },
            {
                path: 'inforDetails',
                name: 'inforDetails',
                component: inforDetails,
                meta: {
                    activeNum: 2,
                    navShow: true,
                    title: '详情',
                    breadcrumbTitle: '详情',
                },
            },
            {
                path: 'Inforlist',
                name: 'Inforlist',
                component: routeReplaceSelf(Inforlist),
                meta: {
                    activeNum: 2,
                    navShow: true,
                    title: '资讯列表',
                    breadcrumbTitle: '资讯列表',
                },
                children: [
                    {
                        path: 'inforDetails',
                        name: 'inforDetails',
                        component: inforDetails,
                        meta: {
                            activeNum: 2,
                            navShow: true,
                            title: '详情',
                            breadcrumbTitle: '详情',
                        },
                    },
                ],
            },
        ],
    },
    {
        path: '/disciconstruc',
        name: 'disciconstruc',
        component: routeReplaceSelf(build),
        meta: {
            navShow: true,
            activeNum: 5,
            title: '全科医学网-学科建设',
            breadcrumbTitle: '学科建设',
        },
        children: [
            {
                path: 'Inforlist',
                name: 'disciconstruc/Inforlist',
                component: routeReplaceSelf(Inforlist),
                meta: {
                    activeNum: 5,
                    navShow: true,
                    title: '学科建设-资讯列表',
                    breadcrumbTitle: '资讯列表',
                },
                children: [
                    {
                        path: 'inforDetails',
                        name: 'inforDetails',
                        component: inforDetails,
                        meta: {
                            activeNum: 5,
                            navShow: true,
                            title: '详情',
                            breadcrumbTitle: '详情',
                        },
                    },
                ],
            },
        ],
    },
    {
        path: '/meeting',
        name: 'meeting',
        component: meeting,
        meta: { navShow: true, activeNum: 4, title: '全科医学网-学术会议' },
    },
    {
        path: '/experts',
        name: 'experts',
        component: experts,
        meta: { navShow: false, activeNum: 6, title: '全科医学网-专家' },
    },
    {
        path: '/expertsDetail',
        name: 'expertsDetail',
        component: expertsDetail,
        meta: { navShow: false, activeNum: 6, title: '全科医学网-专家主页' },
    },
    {
        path: '/organization',
        name: 'organization',
        component: organization,
        meta: { navShow: false, activeNum: 7, title: '全科医学网-机构' },
    },
    {
        path: '/organDetail',
        name: 'organDetail',
        component: organDetail,
        meta: { navShow: false, activeNum: 7, title: '全科医学网-机构主页' },
    },
    {
        path: '/enterprise',
        name: 'enterprise',
        component: enterprise,
        redirect: '/enterprise/qyhome',
        meta: { navShow: true, breadcrumbTitle: '企业专题首页' },
        children: [
            {
                path: 'qyhome',
                name: 'qyhome',
                component: qyhome,
                meta: {
                    navShow: false,
                    activeNum: 'qy0',
                    title: '企业专题首页',
                },
            },
            {
                path: 'enterpriseList',
                name: 'enterpriseList',
                component: enterpriseList,
                meta: {
                    activeNum: 'qy1',
                    title: '企业专题列表页1',
                    breadcrumbTitle: '企业专题列表页1',
                },
            },
            {
                path: 'enterpriseList2',
                name: 'enterpriseList2',
                component: enterpriseList2,
                meta: {
                    activeNum: 'qy2',
                    title: '企业专题列表页2',
                    breadcrumbTitle: '企业专题列表页2',
                },
            },
            {
                path: 'enterpriseDetail',
                name: 'enterpriseDetail',
                component: enterpriseDetail,
                meta: {
                    activeNum: 'qy3',
                    title: '企业专题详情页',
                    breadcrumbTitle: '企业专题详情页',
                },
            },
        ],
    },
    {
        path: '/user',
        name: 'user',
        component: user,
        redirect: '/user/userInfor',
        children: [
            {
                path: 'userInfor',
                name: 'userInfor',
                component: userInfor,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '个人中心' },
            },
            {
                path: 'userData',
                name: 'userData',
                component: userData,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '个人资料修改' },
            },
            {
                path: 'userMyInforShow',
                name: 'userMyInforShow',
                component: userMyInforShow,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '个人资料展示' },
            },
            {
                path: 'userSubscribe',
                name: 'userSubscribe',
                component: userSubscribe,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '开启订阅' },
            },
            {
                path: 'userSubscribeOpera',
                name: 'userSubscribeOpera',
                component: userSubscribeOpera,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '订阅操作' },
            },
            {
                path: 'userSubscribeMenu',
                name: 'userSubscribeMenu',
                component: userSubscribeMenu,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '我的订阅' },
            },
            {
                path: 'userVip',
                name: 'userVip',
                component: userVip,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: 'VIP中心' },
            },
            {
                path: 'userMyCourse',
                name: 'userMyCourse',
                component: userMyCourse,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '我的课程' },
            },
            {
                path: 'userCredits',
                name: 'userCredits',
                component: userCredits,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '学分购买' },
            },
            {
                path: 'userShopping',
                name: 'userShopping',
                component: userShopping,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '我的购物车' },
            },
            {
                path: 'userMyOrder',
                name: 'userMyOrder',
                component: userMyOrder,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '我的订单' },
            },
            {
                path: 'userMyInvoice',
                name: 'userMyInvoice',
                component: userMyInvoice,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '我的发票' },
            },
            {
                path: 'userMyCollection',
                name: 'userMyCollection',
                component: userMyCollection,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '我的收藏' },
            },
            {
                path: 'userExchange',
                name: 'userExchange',
                component: userExchange,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '兑换入口' },
            },
            {
                path: 'userMymsg',
                name: 'userMymsg',
                component: userMymsg,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '我的消息' },
            },
            {
                path: 'userMyMeeting',
                name: 'userMyMeeting',
                component: userMyMeeting,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '我的会议' },
            },
            {
                path: 'userorgCourse',
                name: 'userorgCourse',
                component: userorgCourse,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '机构课程' },
            },
            {
                path: 'userCmeCourse',
                name: 'userCmeCourse',
                component: userCmeCourse,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: 'CME课程' },
            },
            {
                path: 'Personal/Invoicedetail',
                name: 'Invoicedetail',
                component: Invoicedetail,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '发票详情' },
            },
            {
                path: 'Personal/OpenInvoice',
                name: 'OpenInvoice',
                component: OpenInvoice,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '编辑发票' },
            },
            {
                path: 'userExpertsEnter',
                name: 'userExpertsEnter',
                component: userExpertsEnter,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '专家入驻' },
            },
            {
                path: 'userOrgEnter',
                name: 'userOrgEnter',
                component: userOrgEnter,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '机构入驻' },
            },
            {
                path: 'orgEnterUpdate',
                name: 'orgEnterUpdate',
                component: orgEnterUpdate,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '修改入驻信息' },
            },
            {
                path: 'expertsEnterUpdate',
                name: 'expertsEnterUpdate',
                component: expertsEnterUpdate,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '修改入驻信息' },
            },
            {
                path: 'userStoreCenter',
                name: 'userStoreCenter',
                component: userStoreCenter,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '店铺中心' },
            },
            {
                path: 'userLive',
                name: 'userLive',
                component: userLive,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '我的直播' },
            },
            {
                path: 'livesub',
                name: 'livesub',
                component: livesub,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '直播订阅' },
            },
            {
                path: 'liveorder',
                name: 'liveorder',
                component: liveorder,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '直播订单' },
            },
            {
                path: 'livecollect',
                name: 'livecollect',
                component: livecollect,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '直播收藏' },
            },
            {
                path: 'liveclass',
                name: 'liveclass',
                component: liveclass,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '直播课程' },
            },
        ],
    },
    {
        path: '/userStore',
        name: 'userStore',
        component: userStore,
        redirect: '/userStore/project',
        children: [
            {
                path: 'project',
                name: 'usProject',
                component: usProject,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '项目管理' },
            },
            {
                path: 'addProject',
                name: 'usAddProject',
                component: usAddProject,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '新建项目' },
            },
            {
                path: 'updateProject',
                name: 'usUpdateProject',
                component: usUpdateProject,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '修改项目' },
            },
            {
                path: 'student',
                name: 'usStudent',
                component: usStudent,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '学员管理' },
            },
            {
                path: 'creation',
                name: 'usCreation',
                component: usCreation,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '我的资源' },
            },
            {
                path: 'account',
                name: 'usAccount',
                component: usAccount,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '账号管理' },
            },
            {
                path: 'infor',
                name: 'usInfor',
                component: usInfor,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '我的资料' },
            },
            {
                path: 'show',
                name: 'usShow',
                component: usShow,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '我的展示' },
            },
            {
                path: 'link',
                name: 'usLink',
                component: usLink,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '我的link' },
            },
            {
                path: 'updateLink',
                name: 'usUpdateLink',
                component: usUpdateLink,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '修改Link' },
            },
            {
                path: 'imageShow',
                name: 'usImageShow',
                component: usImageShow,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '图文展示' },
            },
            {
                path: 'videoShow',
                name: 'usVideoShow',
                component: usVideoShow,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '视频展示' },
            },
            {
                path: 'statistics',
                name: 'usStatistics',
                component: usStatistics,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '学习情况查询' },
            },
            {
                path: 'equity',
                name: 'usEquity',
                component: usEquity,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '机构会员' },
            },
            {
                path: 'elegant',
                name: 'usElegant',
                component: usElegant,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '机构风采人物' },
            },
            {
                path: 'feature',
                name: 'usFeature',
                component: usFeature,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '机构特色' },
            },
            {
                path: 'course',
                name: 'usCourse',
                component: usCourse,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '自训课程' },
            },
            {
                path: 'cmeCourse',
                name: 'usCmeCourse',
                component: usCmeCourse,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: 'CME课程' },
            },
            {
                path: 'cmeCredits',
                name: 'usCmeCredits',
                component: usCmeCredits,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '学分管理查询' },
            },
            {
                path: 'cmeStatis',
                name: 'usCmeStatis',
                component: usCmeStatis,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '学习情况查询' },
            },
            {
                path: 'cmeCdkey',
                name: 'usCmeCdkey',
                component: usCmeCdkey,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '学习卡查询' },
            },
        ],
    },
    ,
    {
        path: '/userAdmin',
        name: 'userAdmin',
        component: userAdmin,
        redirect: '/userAdmin/Infor',
        children: [
            {
                path: 'infor',
                name: 'uaInfor',
                component: uaInfor,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '店铺信息' },
            },
            {
                path: 'paper',
                name: 'uaPaper',
                component: uaPaper,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '我的论文' },
            },
            {
                path: 'works',
                name: 'uaWorks',
                component: uaWorks,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '我的作品' },
            },
            {
                path: 'broadcast',
                name: 'uaBroadcast',
                component: uaBroadcast,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '音频播报' },
            },
            {
                path: 'dynamic',
                name: 'uaDynamic',
                component: uaDynamic,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '文章动态' },
            },
            {
                path: 'management',
                name: 'uaManagement',
                component: uaManagement,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '作品管理' },
            },
            {
                path: 'link',
                name: 'uaLink',
                component: uaLink,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '我的Link' },
            },
            {
                path: 'center',
                name: 'uaCenter',
                component: uaCenter,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '数据中心' },
            },
            {
                path: 'fans',
                name: 'uaFans',
                component: uaFans,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '粉丝管理' },
            },
            {
                path: 'account',
                name: 'uaAccount',
                component: uaAccount,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '账号管理' },
            },
            {
                path: 'leaveWord',
                name: 'uaLeaveWord',
                component: uaLeaveWord,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '留言管理' },
            },
            {
                path: 'updateDynamic',
                name: 'uaUpdateDynamic',
                component: uaUpdateDynamic,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '修改文章' },
            },
            {
                path: 'updateLink',
                name: 'uaUpdateLink',
                component: uaUpdateLink,
                meta: { navShow: true, requireAuth: true, activeNum: '', title: '修改Link' },
            },
        ],
    },
    {
        path: '/meetingIndex',
        name: 'meetingIndex',
        component: meetingIndex,
        redirect: '/meetingIndex/meetingpc',
        meta: { navShow: false, breadcrumbTitle: '首页' },
        children: [
            {
                path: 'meetingpc',
                name: 'meetingpc',
                component: meetingpc,
                meta: { navShow: false, title: '会议PC端首页' },
            },
            {
                path: 'meetingDetail',
                name: 'meetingDetail',
                component: meetingDetail,
                meta: {
                    navShow: false,
                    title: '会议PC端详情页',
                    breadcrumbTitle: '详情',
                },
            },
        ],
    },
    {
        path: '/meetingMobile',
        name: 'meetingMobile',
        component: meetingMobileIndex,
        redirect: '/meetingMobile',
        // meta: { navShow: true, breadcrumbTitle: '首页' },
        children: [
            {
                path: '',
                name: 'meetingMobile',
                component: meetingMobile,
                meta: { mobileshow: true, navShow: false, title: '会议移动端首页' },
            },
        ],
    },
    {
        path: '/xcx',
        name: 'xcx',
        component: xcx,
        meta: { navShow: false, title: '跳转小程序' },
    },
    {
        path: '/meetingMobileDetail',
        name: 'meetingMobileDetail',
        component: meetingMobileDetail,
        meta: { navShow: false, title: '会议移动端详情页' },
    },
    {
        path: '/muduLive',
        name: 'muduLive',
        component: muduLive,
        meta: { navShow: false, title: '全科医学网' },
    },
    {
        path: '/huodeLive',
        name: 'huodeLive',
        component: huodeLive,
        meta: { navShow: false, title: '全科医学网' },
    },
    {
        path: '/muduLiveMobile',
        name: 'muduLiveMobile',
        component: muduLiveMobile,
        meta: { navShow: false, title: '全科医学网' },
    },
    {
        path: '/huodeLiveMobile',
        name: 'huodeLiveMobile',
        component: huodeLiveMobile,
        meta: { navShow: false, title: '全科医学网' },
    },
    {
        path: '/channelList',
        name: 'channelList',
        component: channelList,
        meta: { navShow: false, title: '直播列表' },
    },
    {
        path: '/question',
        name: 'question',
        component: question,
        meta: { navShow: false, title: '问卷' },
    },
    {
        path: '/questionSuccess',
        name: 'questionSuccess',
        component: questionSuccess,
        meta: { navShow: false, title: '提交成功' },
    },
    {
        path: '/channelListMobile',
        name: 'channelListMobile',
        component: channelListMobile,
        meta: { navShow: false, title: '直播列表' },
    },
    {
        path: '/livelist',
        name: 'livelist',
        component: livelist,
        meta: { navShow: false, title: '直播列表' },
    },
    {
        path: '/mechanismIndex',
        name: 'mechanismIndex',
        component: mechanismIndex,
        redirect: '/mechanismIndex/mechanismHome',
        children: [
            {
                path: 'mechanismHome',
                name: 'mechanismHome',
                component: mechanismHome,
                meta: { activeNum: '', title: '机构入口' },
            },
            {
                path: 'mechanismDetail',
                name: 'mechanismDetail',
                component: mechanismDetail,
                meta: { activeNum: '', title: '机构详情' },
            },
            {
                path: 'expertEnter',
                name: 'expertEnter',
                component: expertEnter,
                meta: { activeNum: '', title: '专家入口' },
            },
            {
                path: 'expertDetails',
                name: 'expertDetails',
                component: expertDetails,
                meta: { activeNum: '', title: '专家详情' },
            },
            {
                path: 'expertLiterature',
                name: 'expertLiterature',
                component: expertLiterature,
                meta: { activeNum: '', title: '专家文献列表' },
            },
        ],
    },
    {
        path: '/qkIndex',
        name: 'qkIndex',
        component: qkIndex,
        redirect: '/qkIndex/qkHome',
        meta: { breadcrumbTitle: '全部课程' },
        children: [
            {
                path: 'qkHome',
                name: 'qkHome',
                component: qkHome,
                meta: { activeNum: '', title: '全科知家首页' },
            },
            { path: 'qkNationalCourse', name: 'qkNationalCourse', component: qkNationalCourse, meta: { activeNum: '', title: '全科知家国际课程' } },
            { path: 'qkallCourse', name: 'qkallCourse', component: qkallCourse, meta: { activeNum: '', title: '全科知家全部课程' } },
            { path: 'qkCourseDetails', name: 'qkCourseDetails', component: qkCourseDetails, meta: { activeNum: '', title: '全科知家课程详情', breadcrumbTitle: '课程详情' } },
            { path: 'qkExpert', name: 'qkExpert', component: qkExpert, meta: { activeNum: '', title: '全科知家专家' } },
            { path: 'qkExpertDetail', name: 'qkExpertDetail', component: qkExpertDetail, meta: { activeNum: '', title: '全科知家专家详情' } },
        ],
    },
    {
        path: '/queryList',
        name: 'queryList',
        component: queryList,
        meta: { title: '项目证书查询' },
    },
    {
        path: '/queryDetail',
        name: 'queryDetail',
        component: queryDetail,
        meta: { title: '项目证书查询' },
    },
    {
        path: '/popsci',
        name: 'popsci',
        component: popsci,
       
        meta: { title: '科普大赛' ,activeNum:9},
    },
    {
        path: '/reading',
        name: 'reading',
        component: reading,
        meta: { title: '读书节' },
    },
    {
        path: '/Loading',
        name: 'Loading',
        component: Loading,
        meta: { navShow: false },
    },
    {
        path: '/e-journal',
        name: 'e-journal',
        component: enindex,
        redirect: '/e-journal/enhome',
        meta: { breadcrumbTitle: 'Home' },
        children: [
            { path: 'enhome', name: 'enhome', component: enhome, meta: { activeNum: 0, title: 'Fmch' } },
            {
                path: '/e-journal/enAllNews',
                name: 'enAllNews',
                component: routeReplaceSelf(enInforList),
                meta: { activeNum: 1, title: '英文资讯列表页', breadcrumbTitle: 'InfoLIst' },
                children: [{ path: '/e-journal/enInforDetail', name: 'enInforDetail', component: enInforDetail, meta: { activeNum: 4, title: '英文资讯详情', breadcrumbTitle: 'InfoDetail' } }],
            },
            {
                path: '/e-journal/enLiteList',
                name: 'enLiteList',
                component: routeReplaceSelf(enLiteList),
                meta: { activeNum: 2, title: '英文文献列表页', breadcrumbTitle: 'LiteLIst' },
                children: [
                    { path: '/e-journal/enLiteList1/enLiteDetail', name: 'enLiteDetail', component: enLiteDetail, meta: { activeNum: 0, title: '英文文献详情', breadcrumbTitle: 'LiteDetail' } },
                ],
            },
            {
                path: '/e-journal/enLiteList2',
                name: 'enLiteList2',
                component: routeReplaceSelf(enLiteList2),
                meta: { activeNum: 0, title: '英文文献列表页2', breadcrumbTitle: 'LiteLIst' },
                children: [
                    { path: '/e-journal/enLiteList2/enLiteDetail', name: 'enLiteDetail2', component: enLiteDetail, meta: { activeNum: 0, title: '英文文献详情', breadcrumbTitle: 'LiteDetail' } },
                ],
            },
            {
                path: '/e-journal/enLiteList3',
                name: 'enLiteList3',
                component: routeReplaceSelf(enLiteList3),
                meta: { activeNum: 0, title: 'enfmchPeriodical', breadcrumbTitle: 'enfmchPeriodical' },
                children: [
                    { path: '/e-journal/enLiteList3/enLiteDetail2', name: 'enLiteDetail3', component: enLiteDetail2, meta: { activeNum: 0, title: '英文文献详情', breadcrumbTitle: 'LiteDetail' } },
                ],
            },
        ],
    },
    {
        path: '/baywindow',
        name: 'baywindow',
        component: baywindow,
    },
    {
        path: '/paySuccess',
        name: 'paySuccess',
        component: paySuccess,
    },
    {
        path: '/userCreditsPaySuccess',
        name: 'userCreditsPaySuccess',
        component: userCreditsPaySuccess,
        meta: { navShow: false, activeNum: '', title: '学分卡购买成功' },
    },
    {
        path: '/course',
        name: 'course',
        component: course,
        meta: { navShow: true, title: '课程详情' },
    },
    {
        path: '/mcourse',
        name: 'mcourse',
        component: mcourse,
        meta: { navShow: false, title: '课程详情' },
    },
    {
        path: '/wxlogin',
        name: 'wxlogin',
        component: wxlogin,
        meta: { navShow: false, title: '微信登录' },
    },
    {
        path: '*',
        name: '404',
        component: nopage,
    },
    {
        path: '/journalxml',
        name: 'journalxml',
        component: uploaddemo,
        meta: { navShow: false, requireAuth: true, breadcrumbTitle: '杂志XML期刊数据上传', title: '杂志XML期刊数据上传' },
    },
];
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err);
};
//replace
const VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(to) {
    return VueRouterReplace.call(this, to).catch(err => err);
};

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to) {
        if (to.hash) {
            return {
                selector: to.hash,
            };
        } else {
            return { x: 0, y: 0 };
        }
    },
});
export default router;
